import { render, staticRenderFns } from "./PageLegal.vue?vue&type=template&id=73d675e3&scoped=true"
import script from "./PageLegal.vue?vue&type=script&lang=js"
export * from "./PageLegal.vue?vue&type=script&lang=js"
import style0 from "./PageLegal.vue?vue&type=style&index=0&id=73d675e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d675e3",
  null
  
)

export default component.exports